<template>
  <div class="order-list">
    <div class="top-info">
      {{ userInfo.customerPhone || userInfo.loginMobile }}
      <span @click="logout" class="logout">退出</span>
    </div>
    <div
      v-for="(item, i) in list"
      :key="i"
      class="order-item"
      @click="toDetail(item)"
    >
      <div class="block-up">
        <div class="tit">
          <span>{{ item.applyProductName }}</span>
          <div :class="getColor(item.appStatus)">{{ item.appStatusName }}</div>
        </div>
        <div class="apl-info">
          <div class="a-i-item">
            <div class="val">
              {{
                +item.appStatus >= 110 ? item.approvalAmount : item.applyAmount
              }}
            </div>
            <div class="name">
              {{ +item.appStatus >= 110 ? "授信金额" : "申请金额" }}
            </div>
          </div>
          <div class="a-i-item">
            <div class="val">
              {{ +item.appStatus >= 110 ? item.approvalTerm : item.applyTerm }}
            </div>
            <div class="name">
              {{ +item.appStatus >= 110 ? "授信期数" : "申请期数" }}
            </div>
          </div>
        </div>
      </div>
      <div class="block-down">
        <div>
          申请日期：<span>{{ item.applyTime }}</span>
        </div>
        <div>
          订单编号：<span>{{ item.bizNo }}</span>
        </div>
      </div>
    </div>
    <div v-if="!list.length" class="none-data">暂无数据</div>
  </div>
</template>
<script>
import { orderList } from "@/api/apply";
import { mapGetters } from "vuex";
import { Dialog } from "vant";
import { celarExpire, clearCache } from "@/utils/app";
export default {
  data() {
    return {
      list: [],
      pro: {},
      userInfo: {}
    };
  },
  created() {
    const { productNo, invitationCode, merchantNo } = this.$route.query;
    if (productNo) {
      const productInfo = {
        productNo,
        invitationCode,
        merchantNo
      };
      window.sessionStorage.setItem(
        "_app_cache_url_params",
        JSON.stringify(productInfo)
      );
    }
  },
  mounted() {
    const userInfo = this.getUserInfo();
    this.userInfo = userInfo || {};
    this.getList();
  },
  methods: {
    ...mapGetters(["getProductInfo", "getUserInfo"]),
    toDetail(item) {
      if (["-1", "-2"].includes(item.appStatus)) return;
      this.$router.push(`/apply-detail?bizNo=${item.bizNo}`);
    },
    async getList() {
      try {
        this.$toast.loading({
          forbidClick: true,
          duration: 0
        });
        const pro = this.getProductInfo();
        this.pro = pro || {};
        let { merchantNo } = pro;
        if (!merchantNo) merchantNo = this.$route.query?.merchantNo || "";
        const { data } = await orderList({ merchantNo });
        this.list = data || [];
        this.$toast.clear();
      } catch (error) {
        this.$errMsg(error);
      }
    },
    getColor(v) {
      if (+v < 0 || +v == 160) return "cr";
      else if (+v == 150) return "cg";
      else return "cb";
    },
    logout() {
      Dialog.confirm({
        title: "提示",
        message: "确定要退出当前用户吗？"
      })
        .then(() => {
          const { merchantNo, productNo, invitationCode, agentNo } = this.pro;
          celarExpire();
          clearCache();
          this.$router.push(
            `/login?productNo=${productNo}&merchantNo=${merchantNo}`
          );
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.order-list {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 40px 32px;
  overflow-y: auto;
  box-sizing: border-box;
  background: linear-gradient(
    to bottom,
    #3fc2ff 0%,
    #60b1ff 25%,
    #acd8ff 40%,
    #ebf6ff 100%
  );
  .top-info {
    line-height: 48px;
    font-size: 14px;
    color: #fff;
  }
  .logout {
    font-size: 24px;
    background-color: #f7dfe2aa;
    border: 1px solid #f8808e;
    color: #ee0a24;
    padding: 0 12px;
    margin-left: 16px;
    border-radius: 8px;
  }
  * {
    box-sizing: border-box;
  }
  .order-item {
    border: 1px solid #efefef;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    padding: 32px;
    margin-bottom: 40px;
    .block-up {
      border-bottom: 1px solid #efefef;
      .tit {
        display: flex;
        justify-content: space-between;
        font-size: 28px;
        color: #333;
        span {
          font-weight: bold;
          font-size: 32px;
        }
        div {
          color: #52c41a;
          &.cr {
            color: #ee0a24;
          }
          &.cb {
            color: #1890ff;
          }
          &.cg {
            color: #52c41a;
          }
          &.co {
            color: #faad14;
          }
        }
      }
      .apl-info {
        display: flex;
        margin: 24px 0;
        align-items: center;
        justify-content: center;
        .a-i-item {
          width: 50%;
          text-align: center;
          .val {
            font-size: 58px;
            &::after {
              content: "元";
              font-size: 12px;
              margin-left: 10px;
            }
          }
          &:last-child .val::after {
            content: "期";
          }
          .name {
            font-size: 12px;
          }
        }
      }
    }
    .block-down {
      margin-top: 20px;
      & > div {
        line-height: 48px;
      }
    }
  }
  .none-data {
    color: #fff;
    font-size: 36px;
  }
}
</style>
